import { Injectable } from '@angular/core';

/**
 * Standard colors used for charts (keep these in sync with colors defined in variables.scss)
 */
@Injectable()
export class ChartColors {

  primary: string = '#51b848';
  blue: string = '#8DCAC6';
  lightBlue: string = '#becac6';
  darkBlue: string = '#0939a4';
  red: string = '#f53d3d';
  yellow: string = '#FFEE88';
  orange: string = '#FFBB88';
  light: string = '#f4f4f4';
  border: string = '#1E88E5';
  white: string = '#ffffff';
  mediumGray: string = '#606060';
  transparent: string = 'rgba(255, 255, 255, 0)';
}






// WEBPACK FOOTER //
// ./src/providers/chart-colors.ts